import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";
//import Etf from "./../../../Images/etf.png";
import Etf from "./../../../Images/home-products/etf.png";
import EtfFAQ from "./EtfFAQ/EtfFAQ";
import { useEffect } from "react";
import TrackApi from "../../Activity_Track/TrackApi";
import { useCookies } from "react-cookie";
function IPOProduct() {
  const [cookies, setCookie] = useCookies(['LeadId']);
  let navigate = useNavigate();
  const routeChange = () => {
    let path = `/AllEquities`;
    navigate(path);
  };
  const trackData=(id)=>{
    const payloadData={
      "RelatedProspectId":id,
      "ActivityNote": "Your ETF Note",
      "mx_Custom_1": "ETF",
      "mx_Custom_2": "ETF page Note",
      "mx_CustomObject_81":window.location.href
     }
     TrackApi(payloadData);
  }
  useEffect(()=>{
  
if(cookies && cookies.RelatedProspectId){
  trackData(cookies.RelatedProspectId);
}
    
  },[])
  return (
    <>
      {/* <div>IPO Product testing</div> */}
      <section className="welcome-equity">
        <Container>
          <Row>
            <Col lg={4} md={6} sm={12}>
              <div className="welcome-img-block">
                <img className="img-fluid" src={Etf} alt="EquityImg" />
              </div>
            </Col>
            <Col lg={8} md={6} sm={12}>
              <div className="welcome-equity-beta">
                <h3>
                  <span>ETF</span>
                </h3>
                <p>
                  An ETF, also known as an exchange-traded fund is a pooled
                  investment of assets that functions similarly to a mutual
                  fund. Unlike mutual funds, ETF typically track a specific
                  index, sector, commodity, etc. ETF prices reflect the Net
                  asset value (NAV) of the basket in which it invests. Most ETF
                  are passively managed and are listed and traded on stock
                  exchanges. In many ways, ETF are like mutual funds, except
                  that ETF are purchased and sold on the stock exchange from
                  existing buyers, whereas mutual funds are purchased and sold,
                  from and to the issuer on the closing price at the end of the
                  day.
                </p>
                {/* <a onClick={routeChange}>
                  <span>Explore</span>
                </a>
                <button type="button">Sign Up</button> */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="why-equity-block">
        <Container className="add-border">
          <Row>
            <Col lg={12} md={12} sm={12}>
              <div className="why-equitie-inn">
                <h3>
                  <span>Why ETF</span>
                </h3>
                <p>
                  ETF are used as investment vehicles by a wide range of investors to diversify their portfolios or gain exposure to specific sectors/industries. ETF can provide an investment avenue with lower costs in comparison to traditional open-end funds, as well as more flexibility, transparency, and tax advantages in taxable accounts. They trade in the same way as stocks do, but their price movements can also be compared to more broad investments.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <EtfFAQ />
    </>
  );
}
export default IPOProduct;
